<template>
    <div>
        <save-login :model="editing" v-if="editing" @close="saved()" @cancel="editing = null" />

        <v-container>
            <div class="d-flex align-center">
                <h1>Logins</h1>
                <v-btn color="primary" class="add-button" @click="add()" text>
                    <v-icon left dark>mdi-plus</v-icon>
                    Add login
                </v-btn>
            </div>
            <v-progress-linear :indeterminate="true" v-if="loading" />

            <v-row v-if="!loading">
                <v-col cols="12" md="6" lg="4" v-for="l in logins" :key="l.id">
                    <v-card>
                        <v-card-title>{{ l.displayName || "noname" }}</v-card-title>
                        <v-card-subtitle>
                            {{ l.email }}<br />
                            <small>{{ l.permissions.join(', ') }}</small>
                        </v-card-subtitle>
                        <v-divider />
                        <v-card-actions>

                            <v-spacer />
                            <v-btn color="primary" @click="edit(l)" dark depressed>
                                <v-icon left dark>mdi-pencil</v-icon>
                                Edit
                            </v-btn>
                            <v-btn color="red" @click="remove(l)" dark depressed>
                                <v-icon left dark>mdi-delete</v-icon>
                                Delete
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<style scoped>
    .add-button {
        margin-left: 10px;
    }
</style>

<script>
import { api } from '@/services/api';
import SaveLogin from "./SaveLogin.vue";
import toast from "@/services/toast";
import modals from "@/services/modals";

export default {
    data: () => ({
        logins: [],
        loading: false,
        editing: null,
        snackbar: false
    }),
    created: function() {
        this.refresh();
    },
    methods: {
        add() {
            this.editing = {
                "visible": true,
                "customerId": this.$route.params.id,
                "permissions": ["customer"]
            };
        },
        edit(data) {
            this.editing = {
                "visible": true,
                "id": data.id,
                "customerId": this.$route.params.id,
                "email": data.email,
                "displayName": data.displayName,
                "permissions": [...data.permissions]
            };
        },
        saved() {
            toast(`Login '${this.editing.email}' ` + (this.editing.id ? "updated" : "created"));

            this.editing = null;
            this.snackbar = true;
            this.refresh();
        },
        async remove(login) {
            if (!await modals.show(`Are you sure you want to delete '${login.email}'?`, "Delete login"))
                return;

            await api("/admin/logins/delete", { id: login.id });
            toast(`Login '${login.name}' deleted`);

            await this.refresh();
        },
        async refresh() {
            this.loading = true;
            this.logins = await api("/admin/logins/list", { customerId: this.$route.params.id });
            this.loading = false;
        }
    },
    components: { SaveLogin }
};
</script>